// Explicit mapping so the cover badge color always matches the publication type
const TYPE_STYLES = {
	"Journal Paper": "journal",
	"Conference Paper": "conference",
	"Book Chapter": "chapter",
};

export default TYPE_STYLES;
